<template>
  <div class="img-box">
    <img :src="img" alt="" class="pay-img">
    <span>请使用微信扫描二维码进行支付</span>
    <el-button type="primary" size="small" style="margin-top: 30px;" @click="handlePay">支付完成</el-button>
  </div>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      
    }
  },
  methods: {
    handlePay(){
      this.$emit('payOk')
    }
  }
}
</script>
<style lang="scss" scoped>
.img-box{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  .pay-img{
    width: 150px;
    height: 150px;
    margin: 0 auto;

  }
}

</style>